import {barnManagerModule} from '../../index.module';
import {downgradeInjectable} from '@angular/upgrade/static';
import {ResponseHandlerService} from '../../../app/core/response-handler/response-handler.service';

barnManagerModule.factory('ng2ResponseHandlerService', downgradeInjectable(ResponseHandlerService));
